import Stencil from "../stencil";

class MetaobjectListFilters extends HTMLElement {
  target;
  definitions;

  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', this.onFilterChange.bind(this));
    this.target = this.closest('metaobject-list');
    this.definitions = JSON.parse(this.getAttribute('definitions'));
  }

  populate(metaobjects) {
    this.definitions.forEach(definition => {
      const filterContainer = this.querySelector(`#metaobject-list-filter-${definition.field_key}`);
      const filterValues = [...new Set(metaobjects
        .map(metaobject => {
          const value = metaobject.fields_keyed[definition.field_key];
          try {
            return JSON.parse(value);
          } catch {
            return value;
          }
        })
        .filter(Boolean) // Remove undefined/null values
        .flat()
      )];

      switch(definition.presentation) {
        case "buttons":
          const buttonsContainer = this.querySelector(`#metaobject-list-filter-${definition.field_key}-buttons`);
          filterValues.forEach(value => {
            const template = this.querySelector('#template-metaobject-list-filter-button');
            const clone = template.content.cloneNode(true);
            const input = clone.querySelector('input');
            const label = clone.querySelector('label');
            input.id = `metaobject-list-filter-${definition.field_key}-input-${Stencil.handleise(value)}`;
            input.name = `metaobject-list-filter-${definition.field_key}-input`;
            input.value = value;
            input.dataset.field = definition.field_key;
            label.htmlFor = input.id;
            label.textContent = value;
            buttonsContainer.appendChild(clone);
          });
          break;
        case "dropdown":
          const select = filterContainer.querySelector('select');
          filterValues.forEach(value => {
            const option = document.createElement('option');
            option.value = value;
            option.textContent = value;
            select.appendChild(option);
          });
          break;
      }
    });
  }

  onFilterChange(e) {
    const filters = Array.from(this.querySelectorAll('.filter-metaobject'));
    const metaobjectElements = this.target.querySelectorAll('.card-metaobject');

    metaobjectElements.forEach(element => {
      const applicableFilters = filters.filter(filter => {
        switch(filter.type) {
          case 'radio':
            return filter.checked;
          default:
            return true;
        }
      });
      const shouldShow = applicableFilters.every(filter => {
        const field = filter.getAttribute('data-field');
        const value = filter.value;
        return !value || element.getAttribute(`data-metaobject-${field}`)?.split(",").includes(value);
      });
      element.style.display = shouldShow ? 'block' : 'none';
    });
  }
}

export default MetaobjectListFilters;